import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useUserGroupsList() {
  return useQuery({
    ...orpc.organization.groups.list.queryOptions(),
    staleTime: 5 * 60 * 1000,
  });
}
